"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricePreview = void 0;
var api_wrapper_1 = require("../../api/api-wrapper");
var element_generator_1 = require("../../element-generator");
var error_handling_1 = require("../../error-handling");
var helper_1 = require("../../helper");
var object_service_1 = require("../../object-service");
var translation_1 = __importDefault(require("../../translation"));
var variables_const_1 = require("../../variables.const");
var form_const_1 = require("./form.const");
var PricePreview = /** @class */ (function () {
    function PricePreview() {
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.errorHandling = object_service_1.ObjectService.getInstance(error_handling_1.ErrorHandling);
        this.generator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
        this.helper = object_service_1.ObjectService.getInstance(helper_1.Helper);
        this.offerings = [];
        this.timeMapping = {
            'Alle 1 Years': translation_1.default.t('yearly'),
            '1 YEARS': translation_1.default.t('yearly'),
            '1 YEAR': translation_1.default.t('yearly'),
            'Alle 12 Monate': translation_1.default.t('yearly'),
            '12 MONTHS': translation_1.default.t('yearly'),
            '12 MONTH': translation_1.default.t('yearly'),
            '1 MONTHS': translation_1.default.t('monthly'),
            '1 MONTH': translation_1.default.t('monthly'),
            'Alle 1 Monate': translation_1.default.t('monthly'),
            '1 WEEKS': translation_1.default.t('weekly'),
            '1 WEEK': translation_1.default.t('weekly'),
            'Alle 1 Wochen': translation_1.default.t('weekly'),
            '1 DAYS': translation_1.default.t('daily'),
            '1 DAY': translation_1.default.t('daily'),
            'Alle 1 Tage': translation_1.default.t('daily'),
        };
        this.pricingDetails = [];
    }
    PricePreview.prototype.initModule = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var waitOffers, renderedEvent;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._studioId = this.helper.getPersistedData(form_const_1.MAPPINGS.location);
                        this._studioName = this.helper.getPersistedData(form_const_1.MAPPINGS.studioNameText);
                        this._membership = this.helper.getPersistedData(form_const_1.MAPPINGS.membershipId);
                        if (!(((_a = this._studioId) === null || _a === void 0 ? void 0 : _a.length) && +this._studioId > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getOfferings()];
                    case 1:
                        waitOffers = _b.sent();
                        if (waitOffers) {
                            this.generatePricingOverview();
                            renderedEvent = new CustomEvent('fms-rendered', {
                                detail: {
                                    rendered: 'price-preview',
                                },
                            });
                            document.dispatchEvent(renderedEvent);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        if (!(variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.legacy)) {
                            //legacy is a onepager and might haven't set the studio at this point in time
                            console.error('No Studio Id defined');
                        }
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PricePreview.prototype.getOfferings = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var offerings, existsForStudio, _i, _b, offer, term;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.apiWrapper.getOfferings(this._studioId)];
                    case 1:
                        offerings = _c.sent();
                        if (offerings === null || offerings === void 0 ? void 0 : offerings.length) {
                            existsForStudio = false;
                            this.offerings = offerings;
                            for (_i = 0, _b = this.offerings; _i < _b.length; _i++) {
                                offer = _b[_i];
                                term = offer.terms.find(function (a) { return String(a.id) === String(_this._membership); });
                                if (term && offer) {
                                    this.selectedTerm = term;
                                    this.selectedOffer = offer;
                                    this.errorHandling.hideErrorMessage();
                                    existsForStudio = true;
                                    return [2 /*return*/, true];
                                }
                            }
                            if (existsForStudio === false && ((_a = this._membership) === null || _a === void 0 ? void 0 : _a.length)) {
                                this.errorHandling.showErrorMessage('Dieses Angebot existiert nicht für das Studio');
                            }
                        }
                        else {
                            this.errorHandling.showErrorMessage('Keine Angebote für Studio gefunden');
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    PricePreview.prototype.generatePricingOverview = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        $(variables_const_1.PRICEOVERVIEWID).empty().removeClass();
        var elements = [];
        if ((_a = this._studioName) === null || _a === void 0 ? void 0 : _a.length) {
            elements.push(this.generator.getRow({
                html: 'Studio ' + this._studioName,
                css: {
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: 'rgba(26, 41, 54, .75)',
                    margin: '10px 0 4px 0',
                },
            }));
        }
        //FIRST HALF
        //FREE BONUS
        if ((_c = (_b = this.selectedTerm) === null || _b === void 0 ? void 0 : _b.rateBonusPeriods) === null || _c === void 0 ? void 0 : _c.length) {
            for (var _i = 0, _q = this.selectedTerm.rateBonusPeriods; _i < _q.length; _i++) {
                var bonus = _q[_i];
                this.bonusTimeElements(elements, bonus);
            }
        }
        var feeSumPrice = 0, sorted = [];
        for (var _r = 0, _s = this.selectedTerm.flatFees; _r < _s.length; _r++) {
            var fee = _s[_r];
            var interval = (fee === null || fee === void 0 ? void 0 : fee.paymentFrequency)
                ? this.timeMapping[fee.paymentFrequency] || fee.paymentFrequency
                : '';
            var row = this.generator.twoColSetup(fee.name, interval + ' ' + translation_1.default.transformCurrency(fee.price) + '€', {
                fontSize: '12px',
            });
            if (fee.paymentFrequencyType === 'RECURRING') {
                elements.push(row);
            }
            else {
                feeSumPrice += fee.price;
                sorted.push(row);
            }
        }
        if (feeSumPrice > 0) {
            elements.push.apply(elements, sorted);
            elements.push(this.generator.twoColSetup(translation_1.default.t('onceFlatRates'), '' + translation_1.default.transformCurrency(this.helper.roundDecimals(feeSumPrice, 2)) + '€', {
                fontWeight: 'bold',
                color: 'rgba(26, 41, 54, .75)',
                marginTop: '4px',
                fontSize: '12px',
            }));
            elements.push(this.generator.getDividerLine());
        }
        //Laufzeiten
        var contractDuration = this.selectedTerm.termValue;
        //SECOND HALF
        this.bonusPeriodInSummary(elements);
        var customerAge = +localStorage.getItem('age');
        var price = this.selectedTerm.price;
        //Age based adjustment stuff
        if (customerAge > 0 &&
            ((_e = (_d = this.selectedTerm) === null || _d === void 0 ? void 0 : _d.ageBasedAdjustmentDtos) === null || _e === void 0 ? void 0 : _e.length) &&
            this.selectedTerm.ageBasedAdjustmentDtos.some(function (a) {
                var _a, _b;
                return customerAge > ((_a = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _a === void 0 ? void 0 : _a.startAge) &&
                    customerAge < ((_b = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _b === void 0 ? void 0 : _b.endAge);
            })) {
            price = this.selectedTerm.ageBasedAdjustmentDtos.find(function (a) {
                var _a, _b;
                return customerAge > ((_a = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _a === void 0 ? void 0 : _a.startAge) &&
                    customerAge < ((_b = a === null || a === void 0 ? void 0 : a.ageRangeDto) === null || _b === void 0 ? void 0 : _b.endAge);
            }).value;
        }
        var paymentInterval = this.selectedTerm.paymentFrequencyValue +
            ' ' +
            this.selectedTerm.paymentFrequencyUnit +
            'S';
        var paymentText = this.timeMapping[paymentInterval] ||
            translation_1.default.t('Every') +
                ' ' +
                this.selectedTerm.paymentFrequencyValue +
                ' ' +
                translation_1.default.t(this.selectedTerm.paymentFrequencyUnit + 'S');
        elements.push(this.generator.twoColSetup(this.selectedOffer.name, paymentText + '    ' + translation_1.default.transformCurrency(price) + '€', { fontSize: '12px', fontWeight: 'bold', color: 'rgba(26, 41, 54, .75)' }));
        elements.push.apply(elements, this.addExtraModules('selectableModules'));
        elements.push.apply(elements, this.addExtraModules('optionalModules'));
        //SubsequentRateDto
        if ((_f = this.selectedTerm) === null || _f === void 0 ? void 0 : _f.subsequentRateDto) {
            var term = this.selectedTerm.subsequentRateDto.terms[0];
            price = term.price;
            this.timeMapping[paymentInterval] ||
                translation_1.default.t('Every') +
                    ' ' +
                    term.paymentFrequencyValue +
                    ' ' +
                    translation_1.default.t(term.paymentFrequencyUnit + 'S');
        }
        //Terms & conditions
        elements.push(this.generator.getDividerLine());
        if (((_g = this.selectedTerm) === null || _g === void 0 ? void 0 : _g.extensionType) === 'NONE') {
            elements.push(this.generator.getRow({
                html: "Der Vertrag endet nach der Erstlaufzeit.",
                css: { fontSize: '12px' },
            }));
        }
        else {
            var termCancellation = void 0;
            if (((_h = this.selectedTerm) === null || _h === void 0 ? void 0 : _h.extensionType) === 'SUBSEQUENT_RATE_DETAIL' &&
                ((_l = (_k = (_j = this.selectedTerm) === null || _j === void 0 ? void 0 : _j.subsequentRateDto) === null || _k === void 0 ? void 0 : _k.terms) === null || _l === void 0 ? void 0 : _l.length)) {
                termCancellation = {
                    value: +this.selectedTerm.subsequentRateDto.terms[0].termValue,
                    unit: this.selectedTerm.subsequentRateDto.terms[0].termUnit,
                };
            }
            else if (((_m = this.selectedTerm) === null || _m === void 0 ? void 0 : _m.extensionType) === 'TERM_EXTENSION') {
                termCancellation = {
                    value: +this.selectedTerm.extensionFixedTerm,
                    unit: this.selectedTerm.extensionFixedTermUnit,
                };
            }
            var cancellationPeriodText = termCancellation &&
                (termCancellation === null || termCancellation === void 0 ? void 0 : termCancellation.value) > 0 &&
                !((termCancellation === null || termCancellation === void 0 ? void 0 : termCancellation.value) === 1 && (termCancellation === null || termCancellation === void 0 ? void 0 : termCancellation.unit) === 'MONTH')
                ? ' um eine ' +
                    termCancellation.value +
                    ' ' +
                    this.i18nInterval(termCancellation.unit, termCancellation.value)
                : ' als monatlich ';
            elements.push(this.generator.getRow({
                html: "Mindestlaufzeit ".concat(contractDuration, " ").concat(translation_1.default.t(contractDuration > 1
                    ? this.selectedTerm.termUnit + 'S'
                    : this.selectedTerm.termUnit), ". Wenn du nicht ").concat(this.selectedTerm.cancellationPeriod, " ").concat(translation_1.default.t(this.selectedTerm.cancellationPeriod > 1
                    ? this.selectedTerm.cancellationPeriodUnit + 'S'
                    : this.selectedTerm.cancellationPeriodUnit), " vor Ablauf der Mindestlaufzeit k\u00FCndigst, wird deine Mitgliedschaft automatisch ").concat(cancellationPeriodText, " k\u00FCndbare Mitgliedschaft zu je \n        \"").concat(paymentText, " ").concat(translation_1.default.transformCurrency(price), "\u20AC\" weitergef\u00FChrt"),
                css: { fontSize: '12px' },
            }));
        }
        var priceAdjustments = '';
        //Price adjustments
        if ((_p = (_o = this.selectedTerm) === null || _o === void 0 ? void 0 : _o.priceAdjustmentRules) === null || _p === void 0 ? void 0 : _p.length) {
            for (var _t = 0, _u = this.selectedTerm.priceAdjustmentRules; _t < _u.length; _t++) {
                var priceAdjustment = _u[_t];
                priceAdjustments += priceAdjustment.defaultDescription;
            }
            elements.push(this.generator.getRow({
                html: priceAdjustments,
                css: { fontSize: '12px' },
            }));
        }
        for (var _v = 0, elements_1 = elements; _v < elements_1.length; _v++) {
            var entry = elements_1[_v];
            $(variables_const_1.PRICEOVERVIEWID).append(entry);
        }
    };
    PricePreview.prototype.addExtraModules = function (localstorageKey) {
        var moduleElements = [];
        var modulesAdded = 0;
        if (localStorage.getItem(localstorageKey)) {
            var selectedModules = JSON.parse(localStorage.getItem(localstorageKey));
            var _loop_1 = function (moduleId) {
                var modules = localstorageKey === 'selectableModules'
                    ? this_1.selectedOffer.selectableModules
                    : this_1.selectedTerm.optionalModules;
                var module_1 = modules.find(function (a) { return +a.id === +moduleId; });
                if (module_1) {
                    modulesAdded++;
                    var priceText = module_1.price === 0 ? translation_1.default.t('free') : translation_1.default.transformCurrency(module_1.price) + '€';
                    if (module_1.paymentFrequencyType === 'RECURRING') {
                        priceText = this_1.i18nPrice(module_1.price, module_1.paymentFrequencyUnit, module_1.paymentFrequencyValue);
                    }
                    moduleElements.push(this_1.generator.twoColSetup(module_1.name, priceText, {
                        fontSize: '12px',
                    }));
                }
            };
            var this_1 = this;
            for (var _i = 0, selectedModules_1 = selectedModules; _i < selectedModules_1.length; _i++) {
                var moduleId = selectedModules_1[_i];
                _loop_1(moduleId);
            }
        }
        if (modulesAdded > 0) {
            moduleElements.unshift(this.generator.twoColSetup(localstorageKey === 'selectableModules'
                ? 'Kostenlose Module'
                : 'Module', '', {
                fontSize: '12px',
                fontWeight: 'bold',
                color: 'rgba(26, 41, 54, .75)',
            }));
            moduleElements.unshift(this.generator.getDividerLine());
        }
        return moduleElements;
    };
    //True = bonustime and False = testzeitraum
    PricePreview.prototype.checkBonusTime = function (bonus) {
        return ((bonus.termValue > 1 && bonus.termUnit === 'MONTH') ||
            (bonus.termValue > 20 && bonus.termUnit === 'DAY'));
    };
    PricePreview.prototype.testOrBonusTime = function (bonus) {
        return this.checkBonusTime(bonus)
            ? translation_1.default.t('bonusTime')
            : translation_1.default.t('freeTest');
    };
    PricePreview.prototype.bonusPeriodInSummary = function (elements) {
        var _a, _b, _c;
        if ((_b = (_a = this.selectedTerm) === null || _a === void 0 ? void 0 : _a.rateBonusPeriods) === null || _b === void 0 ? void 0 : _b.length) {
            var bonus = (_c = this.selectedTerm) === null || _c === void 0 ? void 0 : _c.rateBonusPeriods[0];
            var textValue = bonus.termValue +
                ' ' +
                translation_1.default.t(bonus.termValue > 1 ? bonus.termUnit + 'S' : bonus.termUnit);
            var strategyText = translation_1.default.t('After');
            if (bonus.termStrategy === 'END_OF_CURRENT_TERM') {
                strategyText = translation_1.default.t('After contract period');
            }
            elements.push(this.generator.getRow({
                html: "".concat(strategyText, " ").concat(textValue, " ").concat(this.testOrBonusTime(bonus)),
                css: { fontSize: '12px' },
            }));
        }
    };
    PricePreview.prototype.bonusTimeElements = function (elements, bonus) {
        var _a, _b, _c, _d;
        if (this.checkBonusTime(bonus)) {
            elements.push(this.generator.twoColSetup((_b = (_a = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.pricePreview) === null || _a === void 0 ? void 0 : _a.bonusRateString) !== null && _b !== void 0 ? _b : '14 Tage - kostenlos testen', (_d = (_c = variables_const_1._settings === null || variables_const_1._settings === void 0 ? void 0 : variables_const_1._settings.pricePreview) === null || _c === void 0 ? void 0 : _c.bonusRatePrice) !== null && _d !== void 0 ? _d : '0€', {
                fontSize: '12px',
            }));
        }
        elements.push(this.generator.twoColSetup(bonus.termValue +
            ' ' +
            translation_1.default.t(bonus.termValue > 1 ? bonus.termUnit + 'S' : bonus.termUnit) +
            ' - ' +
            this.testOrBonusTime(bonus), '0€', { fontSize: '12px' }));
    };
    PricePreview.prototype.i18nPrice = function (price, interval, frequency) {
        if (price === 0) {
            return translation_1.default.t('free');
        }
        else {
            if (this.timeMapping[frequency + ' ' + interval]) {
                return this.timeMapping[frequency + ' ' + interval] + ' ' + translation_1.default.transformCurrency(price) + '€';
            }
            var newInterval = this.i18nInterval(interval, price);
            return (translation_1.default.t('Every') +
                ' ' +
                frequency +
                ' ' +
                newInterval +
                ' ' +
                translation_1.default.transformCurrency(price) +
                '€');
        }
    };
    PricePreview.prototype.i18nInterval = function (interval, value) {
        return translation_1.default.t(value > 1 ? interval + 'S' : interval);
    };
    PricePreview.prototype.appendPricingDetails = function (pricingDetails) {
        this.generatePricingOverview();
        this.pricingDetails.push(pricingDetails);
        $(variables_const_1.PRICEOVERVIEWID).append(this.pricingDetails);
    };
    PricePreview.prototype.removePricingDetails = function () {
        this.pricingDetails = [];
        this.generatePricingOverview();
    };
    return PricePreview;
}());
exports.PricePreview = PricePreview;
